import React from "react";
import ReactHtmlParser from "react-html-parser";
import {ProductDescription} from "./ProductDescription";
import { ProductCardActionButton } from "./ProductCardActionButton";
import { ProductMemberPricing } from "./ProductMemberPricing";

export class ProductCardListStyle extends React.Component<any, any> {
	constructor(props:any) {
		super(props);
	}
	
	render(): React.ReactNode {
		var product = this.props.data;

		return (
			<>
			{ product.stock_status === 'instock' || product.manage_stock !== 'no' ?
				<>
					{ ( product.hide_out_of_stock === 'no' || product.stock_status !== 'outofstock' ) ?
						<>
							<div  className="product--list-item row-view">
								<div className="product_wrapper_list">
									<div className="product_list_style">
										<div className="product_list_image_wrapper">
											<div className="product_list_image_content">
												{ product.product_image.length > 0 ?
													<div className='product--image-wrapper'>{ReactHtmlParser(product.product_image)}</div>
													: null 
												}
											</div>
										</div>
										<div className="product_list_content_wrapper">
											<div className="product_list_content_header">
													{
													product.product_permalink.length > 0 ? 
														<a href={ product.product_permalink }>{ product.product_name }</a>
														: <a href='#'>{ product.product_name }</a>
													}
											</div>
												{ product.presenter && product.presenter.length > 0 ? 
													<div className="product_list_content_author">
														Presented by { product.presenter }
													</div>
													: null
												}
												<div className="product_divider"></div>
												<div className="product_list_content">
													{ product.product_description && product.product_description.length > 0 ? 
														<>
															<ProductDescription post_excerpt={product.product_description} product_id={product.product_id} hours={1} />
														</>
														: null
													}
											</div>
											<div className="product_list_footer">
												<div className="product_price">
													<ProductMemberPricing
														productOnSale={product.is_on_sale}
														productInCart={product.in_cart}
														productPurchased={product.purchased}
														productMemPrice={product.product_mem_pricing}
														productPrice={product.product_price}
														productPriceText={product.product_price_txt}
														productRegularPrice={product.product_regular_price}
														product={product}
													/>
												</div>
												<ProductCardActionButton product={product} />
											</div>
										</div>
										</div>
										{product.is_on_sale && product.enable_sale_icon ?
											<>
											{ product.stock_status === 'instock' ?
												<>
													<div className="product_on_sale">Sale!</div>
												</>
												: <div className="product_out_stock">Out!</div>
											}
											</>
											: null
										}
								</div>
							</div>
						</>
						: null
						}
					</>
					: null
				}
			</>
		);
	}
}